import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cutback-page',
  templateUrl: './cutback-page.component.html',
  styleUrls: ['./cutback-page.component.scss']
})
export class CutbackPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
